import React, { useState, useRef, useEffect } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import {
  Row,
  Col,
  Container,
  TFVButton,
  Translate,
} from '../../../Share/components';
import { TFV_EMAIL_INFO } from '../../../Share/constants';
import './style.scss';

function ContactTFV(props) {
  const [showAccordian, setAccordianState] = useState({
    'rowOne-columnOne': false,
    'rowOne-columnTwo': false,
    'rowTwo-columnOne': false,
    'rowTwo-columnTwo': false,
    'rowThree-columnOne': false,
    'rowThree-columnTwo': false,
  });
  useEffect(() => {
    document.title = `Kontakta oss - TFV Kundportal
    `;
  }, []);

  const handleShowAccordian = id => {
    setAccordianState({
      [id]: !showAccordian[id],
    });
  };

  const handleMailClick = e => {
    e.preventDefault();
    window.location.href = `mailto:${TFV_EMAIL_INFO}`;
  };

  const displayIcons = id => {
    if (showAccordian[id]) {
      return <IoIosArrowUp />;
    }
    return <IoIosArrowDown />;
  };
  const scrollRef = useRef(null);
  return (
    <div className="page_content">
      <div className="page-title">
        <div className="title" aria-label="Kontakta oss">
          Kontakta oss
        </div>
        <TFVButton
          type="line-primary"
          text={Translate({
            content: 'settings.sendTFVAnEmail',
          })}
          className="contact_now_button"
          onClick={handleMailClick}
        />
      </div>
      <div className="contact_card_wrapper">
        <div>
          <div className="page-title__new">Telefon</div>
          <div className="page-section-body__new">0770-813 000</div>
        </div>
        <div className="contact_card_wrapper__details">
          <div>
            <div className="page-title__new">Postadress</div>
            <div className="page-section-body__new">Tolkförmedling Väst</div>
            <div className="page-section-body__new">Box 113 05</div>
            <div className="page-section-body__new">404 27 Göteborg</div>
          </div>
          <div>
            <div className="page-title__new">Besöksadress</div>
            <div className="page-section-body__new">
              Johan på Gårdas gata 5A, 4 tr
            </div>
            <div className="page-section-body__new">412 50 Göteborg</div>
          </div>
          <div className="page-title__new link-section">
            <a
              role="link"
              tabIndex={0}
              href="https://www.tolkformedlingvast.se/ovrigt/kontakta-oss.html"
              target="_blank"
              aria-label="Övrig kontaktinformation"
              rel="noreferrer"
            >
              Övrig kontaktinformation
            </a>
            <span className="link-reference">
              {`(Länk till https://www.tolkformedlingvast.se/ovrigt/kontakta-oss.html)`}
            </span>
          </div>
        </div>
        <img
          src="/images/contact-cover.png"
          className="contact_card_wrapper__heading-image"
          aria-label="contact-page-cover"
        />
      </div>
    </div>
  );
}

export default ContactTFV;

function ContactCard({
  addressLine,
  imageUrl,
  place,
  addressCityPostCode,
  customerServiceNumber,
}) {
  return (
    <div className="w-100 contact_card__item">
      <div className="generic_card">
        <div className="contact_image">
          <img src={imageUrl} alt={place} />
        </div>
        <div className="d-flex flex-column">
          <div className="contact_city">{place}</div>
          <div className="contact_address_wrapper">
            <div className="contact_address_wrapper_element">{addressLine}</div>
            <div className="contact_address_wrapper_element">
              {addressCityPostCode}
            </div>
          </div>
          <div className="contact_method_wrapper">
            <div className="mr-2 contact_method_wrapper-name">Kundtjänst:</div>
            <div className="contact_method_wrapper-number">
              <a href={`tel:${customerServiceNumber}`}>
                {customerServiceNumber}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
